module.exports = __webpack_public_path__ + "static/albums-logo-white-8c45d2ceaf59fb616861986096dc8b8b.svg";